import { ThunkDispatch } from "redux-thunk";

import { attemptMethod, hasWindow } from "@utils/general";

import CreateValueModule from "@redux/create-value-module";
import { IState, TExtraThunkArgs, TValueAction } from "@redux/store.types";


import { AddToCartModalData } from "@components/Modals/AddToCartModal/types/addToCartModalData.types";
import { getAddToCartState } from "./addToCart.selectors";
import { $AddToCartModuleName, TAddToCartState } from "./addToCart.types";

const { actions } = CreateValueModule<TAddToCartState>($AddToCartModuleName, {
    isOpen: false,
    isHydrated: false,
});

const ADD_TO_CART_CQ_DATA_PATH =
    "hubofoundation-brand-hubo/components/modal/add-to-cart-modal-component";

export const showAddToCart =
    (data: AddToCartModalData) =>
        async (
            dispatch: ThunkDispatch<IState, TExtraThunkArgs, TValueAction>,
            getState: () => IState,
        ) => {
            const isHydrated = !!getAddToCartState(getState())?.isHydrated;

            if (!isHydrated) {
                let element = document.querySelectorAll<HTMLDivElement>(
                    `div[data-cq-data-path='${ADD_TO_CART_CQ_DATA_PATH}']`,
                )[0];

                if (!element) {
                    const el = document.createElement("div");
                    el.setAttribute("data-cq-data-path", ADD_TO_CART_CQ_DATA_PATH);
                    el.setAttribute("data-custom", "true");
                    el.setAttribute(
                        "data-json",
                        attemptMethod(() => JSON.stringify(data), ""),
                    );
                    document.getElementsByClassName("root")[0].appendChild(el);
                    element = el;
                }

                const hydrator = hasWindow() ? window.hydrator : undefined;
                if (hydrator) {
                    hydrator.rehydrateAEMComponent(ADD_TO_CART_CQ_DATA_PATH);
                } else {
                    return dispatch(
                        actions.update({ isOpen: false, isHydrated: false }),
                    );
                }
            }

            dispatch(actions.update({ isOpen: true, isHydrated: true }));
        };

export const update = actions.update;
